/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_F_Import_IdsInputs */

const cs_pm_f_import_ids = /** @type {(inputs: Pm_F_Import_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID z importu (eBrána)`)
};

const en_pm_f_import_ids = /** @type {(inputs: Pm_F_Import_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import IDs (eBrána)`)
};

/**
* | output |
* | --- |
* | "Import IDs (eBrána)" |
*
* @param {Pm_F_Import_IdsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_f_import_ids = /** @type {((inputs?: Pm_F_Import_IdsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_F_Import_IdsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_f_import_ids(inputs)
	return cs_pm_f_import_ids(inputs)
});